import { render, staticRenderFns } from "./DeleteUserForm.vue?vue&type=template&id=35183f8e&scoped=true&"
import script from "./DeleteUserForm.vue?vue&type=script&lang=js&"
export * from "./DeleteUserForm.vue?vue&type=script&lang=js&"
import style0 from "./DeleteUserForm.vue?vue&type=style&index=0&id=35183f8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35183f8e",
  null
  
)

export default component.exports